export enum HttpMethods {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  HEAD = "HEAD",
  DELETE = "DELETE",
  PATCH = "PATCH",
  OPTIONS = "OPTIONS",
  CONNECT = "CONNECT",
  TRACE = "TRACE"
}

export enum Targets {
  BLANK = "_blank",
  SELF = "_self",
  PARENT = "_parent",
  TOP = "_top"
}
